module.exports = __webpack_public_path__ + "static/media/angle-double-up.bc8a1539.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/angle-double-up.svg
// module id = 2085
// module chunks = 7